<template>
  <div>
    <b-form @submit.prevent="save">
      <b-row>
        <b-col class="mb-3" md="6" lg="4">
          <b-form-group :label="`${$t('ORIGIN_INSTITUTION')} *`" label-size="sm">
            <b-tooltip v-if="showTooltipe" target="tooltip-target-11" placement="top" triggers="focus">{{$t('ORIGIN_INSTITUTION_MORE')}}</b-tooltip>
            <b-form-input
              v-model.trim="name_awarding_institution_original_lang"
              id="tooltip-target-11"
            >
            </b-form-input>
            <validation-description :show="$v.name_awarding_institution_original_lang.$dirty && $v.name_awarding_institution_original_lang.$invalid">
              {{$t('FIELD_MANDATORY')}}
            </validation-description>
          </b-form-group>
        </b-col>
        <b-col class="mb-3" md="6" lg="4">
          <b-form-group :label="`${$t('ECONOMY')} *`" label-size="sm">
            <b-tooltip v-if="showTooltipe" target="tooltip-target-16" placement="top" triggers="focus">{{$t('COUNTRY_MORE')}}</b-tooltip>
            <country v-model="country" id="tooltip-target-16"></country>
            <validation-description :show="$v.country.id.$dirty && $v.country.id.$invalid">
              {{$t('FIELD_MANDATORY')}}
            </validation-description>
          </b-form-group>
        </b-col>
        <b-col class="mb-3" md="6" lg="4">
          <b-form-group :label="$t('CITY_OF_INSTITUTION')" label-size="sm">
            <b-tooltip v-if="showTooltipe" target="tooltip-target-12" placement="top" triggers="focus">{{$t('CITY_OF_INSTITUTION_MORE')}}</b-tooltip>
            <b-form-input
              v-model.trim="city_of_institution"
              id="tooltip-target-12"
            >
            </b-form-input>
          </b-form-group>
        </b-col>
        <b-col class="mb-3" md="6" lg="4">
          <b-form-group :label="`${$t('ACCREDITATION_STATUS')} *`" label-size="sm">
            <b-select :options="recognized"
                      type="select"
                      v-model="accreditation_status">
            </b-select>
            <validation-description :show="$v.accreditation_status.$dirty && $v.accreditation_status.$invalid">
              {{$t('FIELD_MANDATORY')}}
            </validation-description>
          </b-form-group>
        </b-col>

        <b-col class="mb-3" md="6" lg="4">
          <b-form-group :label="`${$t('ACCREDITED_STUDY_PROGRAM')} *`" label-size="sm">
            <b-select :options="options"
                      type="select"
                      v-model="accredited_study_program">
            </b-select>
          </b-form-group>
          <validation-description :show="$v.accredited_study_program.$dirty && $v.accredited_study_program.$invalid">
              {{$t('FIELD_MANDATORY')}}
          </validation-description>
        </b-col>
        <b-col class="mb-3" md="6" lg="4">
          <b-form-group :label="`${$t('LEVEL_OF_QUALIFICATION_ORIGIN_COUNTRY')}`" label-size="sm">
            <b-tooltip v-if="showTooltipe" target="tooltip-target-18" placement="top" triggers="focus">{{$t('LEVEL_OF_QUALIFICATION_ORIGIN_COUNTRY_MORE')}}</b-tooltip>
            <b-select :options="options_level_qualification"
                      v-model="level_qualification_country_origin"
                      id="tooltip-target-18">

            </b-select>
          </b-form-group>
        </b-col>
        <b-col class="mb-3" md="6" lg="4" v-if="institution && institution.hasOwnProperty('id') && institution.id === 24"><!-- only Macedonia -->
          <b-form-group :label="$t('RANKED_ON_SHANGHAI_LIST')" label-size="sm">
            <b-select :options="options_t"
                      type="select"
                      v-model="ranked_shanghai_list">
            </b-select>
          </b-form-group>

        </b-col>
        <b-col class="mb-3" md="6" lg="4">
          <b-form-group :label="`${$t('QUALIFICATION_AWARDING_DATE')} *`" label-size="sm">
            <b-tooltip v-if="showTooltipe" target="tooltip-target-13" placement="top" triggers="focus">{{$t('QUALIFICATION_AWARDING_DATE_MORE')}}</b-tooltip>
            <date-picker :placeholder="$t('SELECT_DATE')" :value="qualification_awarding_date" @change="updateAwardingDate" id="tooltip-target-13"></date-picker>
            <validation-description
              :show="$v.qualification_awarding_date.$dirty && $v.qualification_awarding_date.$invalid">
              {{$t('FIELD_MANDATORY')}}
            </validation-description>
          </b-form-group>
        </b-col>
        <b-col class="mb-3" md="6" lg="4">
          <b-form-group :label="$t('DEGREE_NUMBER_THE_COUNTRY_OF_ORIGIN')" label-size="sm">
            <b-tooltip v-if="showTooltipe" target="tooltip-target-14" placement="top" triggers="focus">{{$t('DEGREE_NUMBER_THE_COUNTRY_OF_ORIGIN_MORE')}}</b-tooltip>
            <b-form-input
              v-model.trim="document_number"
              id="tooltip-target-14"
            >
            </b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mt-2">
        <b-col md="6" lg="6">
          <submit-button :disabled="applicant.status && applicant.status.id !== STATUS_IN_PROCESS" :loading="loading" :c_permission="C_RECOGNITION_SAVE_BUTTON"></submit-button>
        </b-col>
      </b-row>

    </b-form>
  </div>

</template>

<script>
  import {toast} from '@/shared/plugins/toastr'
  import {getErrorMessage} from '@/mixins/error/getErrorMessage'
  import SubmitButton from '@/components/app/AppSubmit'
  import DatePicker from '@/components/app/datetime/DatePicker'
  import {required} from 'vuelidate/lib/validators'
  import ValidationDescription from '@/components/app/form/AppValidationDescription'
  import Country from '@/components/applicant/recognation/fields/Country'
  import {getRecognition,getQualificationAreaList,createRecognition,updateRecognition} from '@/services/recognition/index'
  import {getUser} from "@/services/user";
  import i18n from '@/locale/index'
  import moment from 'moment'
  import {C_RECOGNITION_SAVE_BUTTON} from '@/shared/component_permission'
  import {STATUS_COMPLETE,STATUS_IN_PROCESS} from '@/shared/constants';
  import loading from 'vue-full-loading'


  export default {
    name: "RecognitionUpdateForm",
    data() {
      return {
        STATUS_IN_PROCESS,
        loading:false,
        mainProps: { blank: true, blankColor: '#777', width: 75, height: 75, class: 'm1' },
        C_RECOGNITION_SAVE_BUTTON,
        STATUS_COMPLETE,
        options: [
          {value: null, text: '-'},
          {value: 1, text: i18n.t('YES')},
          {value: 0, text: i18n.t('NO')},
          {value: 3, text: i18n.t('VALID')}
        ],
        options_t: [
          {value: 1, text: i18n.t('YES')},
          {value: 0, text: i18n.t('NO')}
         ],
        recognized: [
          {value: null, text: '-'},
          {value: 1, text: i18n.t('ACCREDITED')},
          {value: 2, text: i18n.t('LICENSED')},
          {value: 3, text: i18n.t('RECOGNIZED')},
          {value: 4, text: i18n.t('NOT_ACCREDITED')}
        ],
        options_level_qualification:[
          {value:null ,text:'-'},
          {value:'1' ,text:1},
          {value:'2' ,text:2},
          {value:'3' ,text:3},
          {value:'4' ,text:4},
          {value:'5' ,text:5},
          {value:'6' ,text:6},
          {value:'6.1' ,text:'6.1'},
          {value:'6.2' ,text:'6.2'},
          {value:7 ,text:7},
          {value:'7.1' ,text:'7.1'},
          {value:'7.2' ,text:'7.2'},
          {value:8 ,text:8},
          {value:9 ,text:9},
          {value:10 ,text:10},
          {value:11 ,text:11},
          {value:12 ,text:12},
          {value:0 ,text: this.$t('NOT_APPLICABLE')}
        ],
          id:null,
          name_awarding_institution_original_lang: null,
          city_of_institution: null,
          accredited_study_program: null,
          accreditation_status: null,
          qualification_awarding_date: null,
          document_number:null,
          ranked_shanghai_list:0,
          level_qualification_country_origin: null,
          country: {
            id: null,
            name: null
          },
          insert_user:{
            first_name:null,
            last_name:null
          },
          update_user:{
            first_name:null,
            last_name:null
          },
          created_at:null,
          updated_at:null
          }
    },
    mixins: [getErrorMessage],
    components: {
      SubmitButton,
      DatePicker,
      ValidationDescription,
      Country
    },
    validations: {
        qualification_awarding_date: {required},
        accreditation_status: {required},
        accredited_study_program: {required},
        name_awarding_institution_original_lang:{required},
        country:{
          id:{required}
        },
      },
    computed: {
      language(){
        return localStorage.getItem('language') ? localStorage.getItem('language') : 'hr'
      },
      institution(){
        return this.$store.getters['institution/getInstitution']
      },
      applicant() {
        return this.$store.getters['applicant/getApplicant']
      },
      user() {
        return this.$store.getters['user/getUser']
      },
      showTooltipe() {
        return Number(this.user.tooltipe) === 1 ? true : false
      }
    },
    methods: {
      updateAwardingDate(value) {
        this.qualification_awarding_date = value
      },
      formatDate(value){
          if(value){
            const momentDate = new moment(value)
            return momentDate.format('DD.MM.YYYY HH:mm')
          } else {
              return null
          }
      },
      save() {
        let object = {
          name_awarding_institution_original_lang: this.name_awarding_institution_original_lang,
          qualification_awarding_date: this.qualification_awarding_date,
          institution_town: this.city_of_institution,
          accreditation_status: this.accreditation_status,
          accredited_study_program: this.accredited_study_program,
          country: this.country.id,
          document_number: this.document_number,
          ranked_shanghai_list:this.ranked_shanghai_list,
          level_qualification_country_origin: this.level_qualification_country_origin,
          tab:2
        }
        this.$v.$touch()
        if (this.$v.$invalid) {
          toast({
            'title': this.$t('VALIDATION_FAILED'),
            'message': null,
            'type': 'error',
            'timeout': 6000
          })
          return
        }
        if (this.id === null) {
          this.createRecognition(object)
        } else {
          this.update(object)
        }
      },
      createRecognition(object) {
        this.loading=true
        object.applicant_id = this.applicant.id
        createRecognition(object)
          .then(response => {
            this.setData(response)
            toast({
              'title': this.$t('NOTIFICATIONS.SAVE_SUCCESS.MESSAGE'),
              'message': null,
              'type': 'success',
              'timeout': 2000
            })
          }, error => {
            toast({
              'title': this.$t('NOTIFICATIONS.SAVE_ERROR.MESSAGE'),
              'message': null,
              'type': 'error',
              'timeout': 2000
            })
          }).finally(()=>{
            this.loading = false
        })

      },
      update(object) {
        this.loading = true
        updateRecognition(this.applicant.id,this.id, object)
          .then(response => {
            this.setData(response)
            toast({
              'title': this.$t('NOTIFICATIONS.SAVE_SUCCESS.MESSAGE'),
              'message': null,
              'type': 'success',
              'timeout': 2000
            })
          }, error => {
            toast({
              'title': this.$t('NOTIFICATIONS.SAVE_ERROR.MESSAGE'),
              'message': null,
              'type': 'error',
              'timeout': 2000
            })
          }).finally(()=>{
            this.loading = false
        })
      },
      fetchRecognition(applicantId){
        getRecognition(applicantId).then(response => {
             this.setData(response)

        }, error => {
        })
      },
      setData(response){
        this.id = response.data.id
        this.name_awarding_institution_original_lang = response.data.name_awarding_institution_original_lang
        this.qualification_awarding_date = response.data.qualification_awarding_date
        this.institution_town = response.data.institution_town
        this.accreditation_status = response.data.accreditation_status
        this.accredited_study_program = response.data.accredited_study_program
        this.country = response.data.country
        this.city_of_institution = response.data.institution_town
        this.document_number = response.data.document_number,
        this.ranked_shanghai_list = response.data.ranked_shanghai_list,
        this.level_qualification_country_origin = response.data.level_qualification_country_origin,
        this.created_at = response.data.created_at,
        this.updated_at = response.data.updated_at,
        this.insert_user = response.data.insert_user,
        this.update_user = response.data.update_user
      },


    },
    watch:{
      '$route.params.id':{
        handler(applicantId){
          this.fetchRecognition(applicantId)
        },
        immediate: true,
        deep:true
      },
      institution:{
        handler(value){
          if(Object.keys(value).length === 0 && this.user.hasOwnProperty('institution') && this.user.institution.id){
            this.$store.dispatch('institution/actionSetInstitution',this.user.institution.id)
          }
        },  immediate:true
      }
    }
  }
</script>

<style lang="scss">

.tooltip-inner {
  background-color: white;
  color: black;
  border: 1px solid #bfc7bd;
}
.hr-origin-bottom {
  width:65%;
  text-align:left;
  margin-left:0
}
.hr-origin {
  width:65%;
  text-align:left;
  margin-left:0;
  margin-top: 5px;
  padding-bottom: 10px;
}
</style>

